import { FiArrowRight } from "react-icons/fi";
import { Button } from "@calcom/ui";
import { TopicCard } from "@calcom/features/topics/components/TopicCard";

import type { Booking } from "experts/lib/getBookingPropsForExpersIds";
import type { getTopics } from "@calcom/features/topics/lib/getTopics";
import { useLocale } from "@calcom/lib/hooks/useLocale";

export type TopicsListProps = {
  header?: string;
  booking: Booking | null;
  topics: Awaited<ReturnType<typeof getTopics>> | undefined;
  footer?: React.ReactNode;
  topicNextAvailableSlot: {
    [key: string]: string | null;
  };
};

export const TopicsList = ({ header, topics, footer, booking, topicNextAvailableSlot }: TopicsListProps) => {
  const { t } = useLocale();
  const topicsWithNextAvailableSlot = topics
    ?.filter((topic) => {
      const nextAvailableSlot = topicNextAvailableSlot[topic.name];
      return nextAvailableSlot != null;
    })
    .slice(0, 3);

  return (
    <>
      <section id="topics">
        <div className="container py-12 md:py-32">
          {header && (
            <header className="mb-12 flex flex-wrap justify-between gap-3">
              <h2 className="text-4xl md:text-5xl">{header}</h2>
              <Button size="2xl" color="secondary" EndIcon={FiArrowRight} href="/consultations/topics">
                {t("topics_see_all")}
              </Button>
            </header>
          )}
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-10 xl:grid-cols-3">
            {topicsWithNextAvailableSlot?.map((topic, index) => (
              <TopicCard
                key={topic.id}
                topic={topic}
                booking={booking}
                userList={topic.userList}
                topicNextAvailableSlot={topic.name ? topicNextAvailableSlot[topic.name] : null}
                className={index === topicsWithNextAvailableSlot.length - 1 ? "hidden xl:flex" : ""}
              />
            ))}
          </div>
          {footer && <footer className="mt-12 flex">{footer}</footer>}
        </div>
      </section>
    </>
  );
};
